let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("68Kzv"), load("3NvtU"), load("aCZKp")]).then(() => parcelRequire('2lPrs'));